import { Avatar, Button, Grid, Paper, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import logoWhite from '../assets/logo-icon-white.png'
import { MobileNumberValidation } from '../utils/MobileNumberCheck';
import { setAuth, setAuthenticationToken } from '../utils/TokenHandler';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';

let timer;

function LoginByMobile(props) {
    const paperStyle = {
        padding: 20,
        height: 350,
        width: 250,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto'
    };

    const avatarStyle = {
        background: '#2e3192',
        width: '100px',
        height: '100px'
    };

    const imgStyle = {
        width: "70px",
        height: '70px'
    };

    const formElementStyle = {
        margin: "10px 0"
    };

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset'
            }
        }
    }));

    const classes = useStyles();

    //State----------------------------------------------------------------------------------
    const [mobileNumber, setMobileNumber] = useState('');
    const [userName, setUserName] = useState('');
    const [confirmCode, setConfirmCode] = useState('');
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [sendCodeAgain, setSendCodeAgain] = useState(180);
    //---------------------------------------------------------------------------------------

    const loginHandler = (e) => {
        debugger;
        axios.post('api/v2/Authorization/ConfirmSMS', null, {
            params: {
                mobileNumber: mobileNumber,
                confirmCode: confirmCode,
                IsFromWeb: true
            }
        }).then(response => {
            if (response.data && response.data.access_token !== "Wrong Code") {
                setAuthenticationToken(response.data);
                setAuth(response.data.access_token);
                props.history.push('/');
            }
            else if (response.data.access_token === "Wrong Code") {
                setMessageNotify({
                    severity: "warning",
                    message: "کد وارد شده صحیح نمی باشد",
                    open: true
                });
            }
            else {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ورود به باشگاه",
                    open: true
                });
            }
        }).catch(e => {
            setMessageNotify({
                severity: "error",
                message: "خطا در ورود به باشگاه",
                open: true
            });
        });
    }

    const sendCode = (e) => {
        let mobileObject = MobileNumberValidation(userName);
        if (mobileObject.isValid) {
            axios.get('api/v2/Authorization/MobileDirectLogin', {
                params: {
                    phoneNumber: mobileObject.validNumber,
                    isFromAPP: false
                }
            }).then(res => {
                if (res.data.requiredConfirm) {
                    timer = window.setInterval(() => {
                        setSendCodeAgain(prevTime => {
                            if (prevTime <= 1) {
                                window.clearInterval(timer);
                            }
                            return prevTime - 1
                        });
                    }, 1000);
                    setMobileNumber(mobileObject.validNumber);
                } else {
                    setMessageNotify({
                        severity: "error",
                        message: "خطا در ورود به باشگاه",
                        open: true
                    });
                }
            }).catch(e => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ورود به باشگاه",
                    open: true
                });
            })
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "شماره تلفن همراه به صورت صحیح وارد نشده است",
                open: true
            });
        }
    }

    const MobileConmponent = <>
        <TextField type="number" value={confirmCode} onChange={e => setConfirmCode(e.target.value)} style={formElementStyle} className={classes.root} placeholder="کد فعال سازی را وارد کنید" label="کد فعال سازی" variant="standard" required fullWidth />
        <Button onClick={loginHandler} style={formElementStyle} type="submit" variant="contained" fullWidth>ورود</Button>
        {(sendCodeAgain === 0 ? <Button style={{ color: '#000000' }} onClick={(e) => { setSendCodeAgain(180); sendCode(e); }} variant="text" fullWidth>ارسال مجدد کد فعال سازی</Button> : <h5 style={{ textAlign: 'center' }}>{Math.floor(sendCodeAgain / 60) + ':' + (sendCodeAgain % 60)}</h5>)}
    </>;

    const ConfirmCodeConmponent = <>
        <TextField value={userName} onChange={e => setUserName(e.target.value)} style={formElementStyle} className={classes.root} placeholder="نام کاربری(شماره موبایل) را وارد کنید" label="نام کاربری(شماره موبایل)" variant="standard" required fullWidth />
        <Button onClick={sendCode} style={formElementStyle} type="submit" variant="contained" fullWidth>دریافت کد</Button>
    </>;

    return (
        <>
            <Grid>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <Avatar style={avatarStyle}><img style={imgStyle} src={logoWhite} alt="NEC" /></Avatar>
                        <h2>باشگاه مشتریان NEC</h2>
                    </Grid>
                    {mobileNumber ? MobileConmponent : ConfirmCodeConmponent}
                    <Button onClick={e => { props.history.push('/login') }} variant="text" fullWidth>ورود با نام کاربری و کلمه عبور</Button>
                </Paper>
            </Grid>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <div style={{ height: '90vh' }}></div>
        </>)
}

export default LoginByMobile;